export const alphaNumericInputValidation = (value, maxLength = 100) => {
	const val = (value || "").replace(/[^A-Za-z0-9 ]/g, "");
	return val.slice(0, maxLength);
};
export const isValidAlphaNumeric = (value) =>
	/^[A-Za-z0-9 ]+$/.test((value || "").trim());

export const validateAlphaNumeric = (
	value,
	fieldLabel = "Value",
	maxLength = 100,
) => {
	if (!value) {
		return { message: `${fieldLabel} is required`, valid: false };
	}
	if (/^\s/.test(value)) {
		return {
			message: `${fieldLabel} should not start with a space`,
			valid: false,
		};
	}
	if (value.length > maxLength) {
		return {
			message: `${fieldLabel} should not exceed ${maxLength} characters`,
			valid: false,
		};
	}
	if (!isValidAlphaNumeric(value)) {
		return {
			message: `${fieldLabel} must contain only letters, numbers, and spaces`,
			valid: false,
		};
	}
	return { message: "", valid: true };
};